import { inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { PromanStateService } from '@frontend/shared/services/proman-state.service';
import { Store } from '@ngrx/store';
import { take } from '@proman/rxjs-common';
import { getCurrUser } from '@proman/store/curr-user';

@Injectable({
    providedIn: 'root',
})
export class GuardsAdminService implements CanActivate {
    private store = inject(Store);
    private PromanState = inject(PromanStateService);

    async canActivate(): Promise<boolean> {
        const currUser = await new Promise<any>((resolve) => {
            this.store.select(getCurrUser).pipe(take(1)).subscribe(resolve);
        });

        const isAdmin = currUser?.person?.isAdmin;
        if (!isAdmin) {
            this.PromanState.go();
        }

        return !!isAdmin;
    }
}
